export default __webpack_public_path__ + "static/media/employeeManagement.721c88b0.gif";